import { render } from "./RegulationsRodoDeclarations.vue?vue&type=template&id=248a6ffd&scoped=true"
import script from "./RegulationsRodoDeclarations.vue?vue&type=script&lang=js"
export * from "./RegulationsRodoDeclarations.vue?vue&type=script&lang=js"

import "./RegulationsRodoDeclarations.vue?vue&type=style&index=0&id=248a6ffd&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248a6ffd"]])

export default __exports__